import { render, staticRenderFns } from "./TireRegisterInputPaint.vue?vue&type=template&id=22f4d999&scoped=true"
import script from "./TireRegisterInputPaint.vue?vue&type=script&lang=ts"
export * from "./TireRegisterInputPaint.vue?vue&type=script&lang=ts"
import style0 from "./TireRegisterInputPaint.vue?vue&type=style&index=0&id=22f4d999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f4d999",
  null
  
)

export default component.exports